<template>
  <div v-if="isMissingRequirements" class="unit-card__alert-bottom prereq">
    <span class="unit-card__alert-bottom-content" :id="`tooltip-offering-alert-${code}`">
      Offering not available <i class="far fa-info-circle"></i>
    </span>
    <button type="button" class="unit-card__alert-bottom-action"
      v-on:click="openSlideOut({component: slideOutComponent, componentProperties: slideOutComponentProperties})">
      See details
    </button>

    <b-tooltip :target="`tooltip-offering-alert-${code}`" triggers="hover" placement="right" noninteractive>
      The unit you have selected does not have any valid offerings.
    </b-tooltip>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import offeringsValidator from 'common/helpers/offerings-validator.js'
import SlideOutUnitDetailsView from './slide-out-tree-view/SlideOutUnitDetailsView.vue'
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    firstLevelTitle: {
      type: String,
      required: true
    },
    code: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      slideOutComponent: SlideOutUnitDetailsView,
      slideOutComponentProperties: {
        relationship: this.item.relationship,
        location: this.item.location,
        firstLevelTitle: this.item.firstLevelTitle
      }
    }
  },
  methods: {
    ...mapMutations('global', {
      openSlideOut: 'openSlideOut'
    })
  },
  computed: {
    ...mapGetters({
      selectedCourse: 'courses/getSelectedCourse',
      selectedPreferences: 'preferences/getSelectedStudyPreferences',
      teachingPeriods: 'preferences/getTeachingPeriods'
    }),
    isMissingRequirements() {
      return !offeringsValidator.offeringsExistTest(this.selectedCourse, this.item, this.selectedPreferences, this.teachingPeriods)
    }
  }
}
</script>
